const SITE_URL = "https://www.usepinned.com";

export function getOrganizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Pinned",
    url: SITE_URL,
    description: "Travel discovery app — real photos, real reviews, real travelers",
  };
}

export function getPostSchema(post) {
  if (!post || !post.latitude || !post.longitude) return null;

  return {
    "@context": "https://schema.org",
    "@type": "Place",
    name: post.locationName || post.caption,
    geo: {
      "@type": "GeoCoordinates",
      latitude: post.latitude,
      longitude: post.longitude,
    },
    image: post.imageUrl,
    review: {
      "@type": "Review",
      author: {
        "@type": "Person",
        name: post.user?.username,
      },
      reviewBody: post.caption,
    },
  };
}

export function getProfileSchema(user) {
  if (!user) return null;

  const schema = {
    "@context": "https://schema.org",
    "@type": "Person",
    name: [user.firstName, user.lastName].filter(Boolean).join(" ") || user.username,
    url: `${SITE_URL}/profile/${user.username}`,
  };

  if (user.avatarUrl) {
    schema.image = user.avatarUrl;
  }

  return schema;
}
